import { authRequest } from "../utils/netRequest";

export class PaymentService {
  async getToken() {
    return await authRequest({
      url: "/payment-methods/client-token",
      method: "get",
    });
  };
  async putCard(data) {
    return await authRequest({
      url: "/payment-methods",
      method: "put",
      data,
    });
  };
  async getCard() {
    return await authRequest({
      url: "/payment-methods",
      method: "get",
    });
  };
  async deleteCard(token) {
    return await authRequest({
      url: `/payment-methods/${token}`,
      method: "delete",
    });
  };
}

export default new PaymentService();


